import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const SearchBoxContainer = styled.div`
  width: ${() => `${viewSizeCalculator(22.5)}`};
  height: ${() => `${viewSizeCalculator(3)}`};

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${() => `${viewSizeCalculator(0.675)}`};

  position: relative;

  background-color: #f6f6f6;
  border: ${() => `${viewSizeCalculator(0.125)} solid #ebebeb`};
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem

  opacity: 0rem;
`;

export const Input = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background-color: transparent;

  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1.063rem

  margin-left: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem

  &::placeholder {
    color: #aaa;
    font-size: ${() => `${viewSizeCalculator(0.875)}`};
    font-weight: 400;
    line-height: ${() => `${viewSizeCalculator(1.059)}`};
  }
`;

export const SearchIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  left: 90%;
  svg {
    width: ${() => `${viewSizeCalculator(3)}`}; // 3rem
    height: ${() => `${viewSizeCalculator(3)}`}; // 3rem
  }
`;

export const SuggestionsList = styled.ul`
  position: absolute;
  top: ${() => `${viewSizeCalculator(3.4)}`};
  left: 0;
  width: 100%;
  background: white;
  overflow-x: hidden;
  z-index: 101;
  list-style: none;
  padding: ${() => `${viewSizeCalculator(0.5)}`};
  margin: 0;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  /* border-top-right-radius: 0; */
  /* border-bottom-right-radius: 0; */

  box-shadow: 0 0.0625rem 0.3125rem #3333331a;

  ${({ isAtEnd }) =>
    isAtEnd &&
    `
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: ${viewSizeCalculator(4)};
        background: linear-gradient(
          to top,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0)
        );
        pointer-events: none;
        border-bottom-left-radius: ${viewSizeCalculator(1.25)};
        border-bottom-right-radius: ${viewSizeCalculator(1.25)};
      }
    `}

`;

export const SuggestionsScroll = styled.div`
  max-height: ${() => `${viewSizeCalculator(15)}`};
  overflow-y: auto;
  /* Stop scroll from chaining to the parent container once the list reaches
     its top/bottom. */
  overscroll-behavior: contain;
  margin-right: ${() => `${viewSizeCalculator(0.2)}`};

  &::-webkit-scrollbar {
    width: ${() => `${viewSizeCalculator(5, true)}`};
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: ${() => `${viewSizeCalculator(4, true)}`};
    margin: ${() => `${viewSizeCalculator(4, true)}`} 0;
  }

  &::-webkit-scrollbar-thumb {
    background: #3333334d;
    border-radius: ${() => `${viewSizeCalculator(4, true)}`};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #33333380;
  }
`;

export const ListElement = styled.li`
  padding: ${() => `${viewSizeCalculator(1)}`};
  margin-right:  ${viewSizeCalculator(0.4)};
  border-radius: ${viewSizeCalculator(0.625)};
  font-size: ${() => `${viewSizeCalculator(1)}`};
  color: #333333;
  cursor: pointer;
  &:hover,
  &.highlighted {
    background-color: #f9f9f9;
  }
  text-transform: capitalize;
`;
